import React from "react";

const FormTitle = ({ icon, title, data }) => {
  return (
    <div className="personalInfoTitleSec">
      {icon}
      <div className="personalInfoTitleLine">
        <p className="personalInfoTitle">{title}</p>
        {data && <p className="personalInfoData">{data}</p>}
      </div>
    </div>
  );
};

export default FormTitle;
